(ns humbleai.belt.download
  "Trigger a file download from the frontend

  Generates a hidden link with a data URL and a `download` attribute, then
  mimics clicking on that link. Useful e.g. to \"download\" things like CSVs
  generated inside the frontend. "
  (:require [kitchen-async.promise :as p]))

(defn download!
  "Trigger a download with given filename, file contents, and mime-type (hint to
  the browser for how to handle the file)."
  [filename data mime-type]
  (p/let [chunks (if (string? data)
                   (p/->promise data)
                   (.arrayBuffer (js/Response. data)))
          blob (p/->promise
                (js/Blob. #js [chunks]
                          #js {"type" (str mime-type (when (= "text" (subs mime-type 0 4)) ";charset=utf-8;"))}))
          url (p/->promise
               (js/URL.createObjectURL blob))]

    (doto (.createElement js/document "a")
      (.setAttribute "href" url)
      (.setAttribute "download" filename)
      (.click))))
